import { gql } from 'graphql-request';
import {
  AudienceFragment,
  LayoutFragment,
  LocationFragment,
  UpdatesFragment,
  UserSettingsFragment,
} from '../fragments/fragments';

export const GET_USER_ADMIN = gql`
  ${UpdatesFragment}
  ${LocationFragment}
  ${UserSettingsFragment}
  ${LayoutFragment}
  ${AudienceFragment}

  query GetUserAdmin {
    findCurrentUser {
      id
      firstName
      lastName
      email
      role
      adminType
      settings {
        ...UserSettingsFragment
      }
      operatorDetails {
        userPreferenceQuestions {
          id
          answers {
            description
            key
          }
          endDate
          question
        }
        id
        name
        description {
          en
          heb
        }
        websiteUrl
        layout {
          ...LayoutFragment
        }
        offerDetails {
          category
          customCategory
          strategy
          offerStartDate
          kpis {
            key
            value
          }
          description {
            en
            heb
          }
          id
          location {
            ...LocationFragment
          }
          name
          audience {
            ...AudienceFragment
          }
          operatorId
        }
        contacts {
          fax
          main
          phone
          email
          name
          mobile
        }
        updatesDetails {
          ...UpdatesFragment
        }
        fundDetails {
          # investmentDetails {
          #   ...InvestmentFragment
          # }
          # description
          inceptionDate
          closingDate
          id
          name
          operatorId
          status
          # currency
          # layout {
          #   ...LayoutFragment
          # }
          # portfolio {
          #   key
          #   value
          #   group
          # }
          # distributions {
          #   date
          #   value
          # }
          # projectDetails {
          #   description
          #   category
          #   customCategory
          #   name
          #   portfolio {
          #     key
          #     value
          #   }
          #   fundId
          #   id
          #   location {
          #     ...LocationFragment
          #   }
          # }
          # updatesDetails {
          #   ...UpdatesFragment
          # }
          # properties {
          #   ...EntityPropertiesFragment
          # }
        }
        projectDetails {
          # investmentDetails {
          #   ...InvestmentFragment
          # }
          id
          # category
          # customCategory
          # currency
          # calculationType
          # inceptionDate
          # closingDate
          operatorId
          status
          # layout {
          #   ...LayoutFragment
          # }
          # portfolio {
          #   key
          #   value
          # }
          # location {
          #   ...LocationFragment
          # }
          # updatesDetails {
          #   ...UpdatesFragment
          # }
          name
          kpis
          # properties {
          #   ...EntityPropertiesFragment
          # }
          # distributions {
          #   date
          #   value
          # }
          # investmentDetails {
          #   amount
          #   email
          #   percentage
          #   period
          #   exitDate
          #   isContribution
          #   type
          #   id
          #   date
          #   investedBy
          #   holdings {
          #     date
          #     value
          #   }
          # }
        }
      }
    }
  }
`;
